import React from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

import "./listaEquipamentos.css";
import verificandoToken from '../../../FuncoesGerais/VerificarToken';
import { ensureProtocol } from '../../../config/backend';

function ListaEquipamentos(props) {

    const deleteSistemas = async (codEqp) => {

        let confirmacao = window.confirm("Você realmente deseja excluir o equipamento " + codEqp + "?");

        verificandoToken();

        const token = localStorage.getItem('token');

        if (confirmacao) {
            try {

                await axios.delete(ensureProtocol(localStorage.getItem("ipBackend2")) + "/equipamentos", {
                    headers: {
                        Authorization: `${token}`
                    },
                    data: {
                        codEqp
                    }
                });

                alert("Equipamento " + codEqp + " deletado com sucesso!");

                window.location.reload();

            } catch (error) {
                console.error('Erro:', error);
            }
        }
    };

    return (
        <div className="lista-wrapper">
            <table className="table table-modern align-middle">
                <thead>
                    <tr>
                        <th scope="col">Código</th>
                        <th scope="col">Identificação</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Layout</th>
                        <th scope="col">Descrição</th>
                        <th scope="col">Situação</th>
                        <th scope="col" width="120">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {(props.arrayEquipamentos || []).map((equipamento, index) => {
                        const cod = equipamento.codeqp ?? equipamento.CODEQP;
                        const sit = (equipamento.siteqp ?? equipamento.SITEQP ?? '').toString();
                        const idepro = (equipamento.idepro ?? equipamento.IDEPRO) || '—';
                        return (
                        <tr
                            key={cod != null ? cod : `eqp-${index}`}
                            className={props.onEdit ? 'table-row-clickable' : ''}
                            onClick={() => props.onEdit && props.onEdit(cod)}
                        >
                            <td>{cod}</td>
                            <td>{idepro}</td>
                            <td>
                                {props.onEdit ? (
                                    <button type="button" className="btn btn-link p-0" onClick={(e) => { e.stopPropagation(); props.onEdit(cod); }} title="Editar">{equipamento.nomeqp ?? equipamento.NOMEQP}</button>
                                ) : (
                                    <Link to={{ pathname: '/equipamentos', state: { editId: cod } }} title="Editar">{equipamento.nomeqp ?? equipamento.NOMEQP}</Link>
                                )}
                            </td>
                            <td><span className="text-truncate d-inline-block" style={{ maxWidth: 120 }} title={equipamento.layeqp ?? equipamento.LAYEQP}>{(equipamento.layeqp ?? equipamento.LAYEQP) || '—'}</span></td>
                            <td><span className="text-truncate d-inline-block" style={{ maxWidth: 160 }} title={equipamento.deseqp ?? equipamento.DESEQP}>{(equipamento.deseqp ?? equipamento.DESEQP) || '—'}</span></td>
                            <td>
                                <span className={`badge-pill ${sit === 'A' ? 'badge-ativo' : 'badge-inativo'}`}>
                                    {sit === 'A' ? 'Ativo' : 'Inativo'}
                                </span>
                            </td>
                            <td onClick={(e) => e.stopPropagation()}>
                                {props.onEdit ? (
                                    <button className="btn btn-outline-primary btn-sm me-1" onClick={() => props.onEdit(cod)} type="button" title="Editar"><i className="fas fa-pen" /></button>
                                ) : (
                                    <Link to={{ pathname: '/equipamentos', state: { editId: cod } }} className="btn btn-outline-primary btn-sm me-1" title="Editar"><i className="fas fa-pen" /></Link>
                                )}
                                <button className="btn btn-danger btn-sm" onClick={() => deleteSistemas(cod)} type="button" title="Excluir"><i className="fas fa-trash" /></button>
                            </td>
                        </tr>
                    );})}
                </tbody>
            </table>
        </div>
    );
}

export default ListaEquipamentos;
